import { render, staticRenderFns } from "./PuckDialog.vue?vue&type=template&id=3a8a0f04"
import script from "./PuckDialog.vue?vue&type=script&lang=js"
export * from "./PuckDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports